import ShareChallenge from './ShareChallenge';

export default ShareChallenge;
